// extracted by mini-css-extract-plugin
export default {"container":"MoveToBag___MoveToBag-module__container___xGRDN","button":"MoveToBag___MoveToBag-module__button___yKstM"};